import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ButtonModule} from '../../custom-components/button/button.module';
import {SafeHtmlSanitizerModule} from '../../pipes/safe-html-sanitizer/safe-html-sanitizer.module';
import { MedicineListDialogComponent } from './medicine-list-dialog.component';

@NgModule({
  declarations: [MedicineListDialogComponent],
  imports: [
    CommonModule, 
    ButtonModule, 
    SafeHtmlSanitizerModule
  ],
  exports: [MedicineListDialogComponent]
})

export class MedicineListDialogModule {
}
